import React, { Component } from 'react';
import { Container, Nav } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { LinkContainer } from 'react-router-bootstrap';
import { Route, Switch } from 'react-router-dom';

import AuthRequiredView from 'component/common/AuthRequiredView';

import { USER_NAV_ROUTE } from 'utils/RouteUtil';
import ServerConfig from 'utils/ServerConfig';

import './UserNavigator.scss';

class UserNavigator extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.menuList = ['my_profile', 'my_card', 'profile_my_coupons'];
    this.menuEventKeyList = ['myProfile', 'myCard', 'myCoupon'];
    if (!ServerConfig.getNoTicket()) {
      this.menuList.push('myTicket');
      this.menuEventKeyList.push('myTicket');
    }
    this.menuList.push('profile_my_account');
    this.menuEventKeyList.push('myAccount');
  }

  activeKey = () => {
    const eventKey = this.props.match.params?.page;
    if (this.menuEventKeyList.includes(eventKey)) {
      return eventKey;
    }
    return 'myCoupon';
  };

  dropdownNavTitle = () => {
    const eventKey = this.props.match.params?.page;
    const index = this.menuEventKeyList.indexOf(eventKey);
    if (index !== -1) {
      return this.menuList[index];
    }
    return 'profile_my_coupons';
  };

  render() {
    return (
      <div className="user_container_background">
        <div className="user_nav_container">
          <Container>
            <Nav activeKey={this.activeKey()} className="user_nav">
              {this.menuList.map((navItem, index) => {
                const active =
                  this.menuEventKeyList[index] === this.activeKey();
                const offerNavItemClassName = active
                  ? 'nav-link active subheading'
                  : 'nav-link subheading';
                return (
                  <Nav.Item key={index}>
                    <LinkContainer to={`/user/${this.menuEventKeyList[index]}`}>
                      <div className={offerNavItemClassName}>
                        {this.props.t(navItem)}
                      </div>
                    </LinkContainer>
                  </Nav.Item>
                );
              })}
            </Nav>
          </Container>
        </div>
        <Container className="user_container">
          <Switch>
            {USER_NAV_ROUTE.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                exact={route.exact}
                render={(props) => {
                  const Component = route.component || route.render;
                  if (route?.isAuthProtected) {
                    return (
                      <AuthRequiredView>
                        <Component {...props} />
                      </AuthRequiredView>
                    );
                  }
                  return <Component {...props} />;
                }}
              />
            ))}
          </Switch>
        </Container>
      </div>
    );
  }
}

export default withTranslation()(UserNavigator);
